import { optionalPositiveInteger, optionalTrimmedString } from '../../lib/routeSearch';
import {
  DebugSortDirection,
  debugPageSizes,
  defaultDebugListFilter,
  isDebugSortProperty,
  type DebugListFilter,
  type DebugSortProperty,
} from './model';

export interface DebugRouteSearch {
  search?: string;
  page?: number;
  size?: number;
  sortProperty?: DebugSortProperty | null;
  sortDirection?: DebugSortDirection;
}

export function debugRouteSearchSchema(search: Record<string, unknown>): DebugRouteSearch {
  const searchTerm = optionalTrimmedString(search['search']);
  const page = optionalPositiveInteger(search['page']);
  const parsedSize = optionalPositiveInteger(search['size']);
  const size =
    parsedSize && debugPageSizes.includes(parsedSize as (typeof debugPageSizes)[number])
      ? parsedSize
      : undefined;
  const rawSortProperty = optionalTrimmedString(search['sortProperty']);
  const sortProperty =
    rawSortProperty && isDebugSortProperty(rawSortProperty) ? rawSortProperty : undefined;
  const sortDirection = Object.values(DebugSortDirection).includes(
    search['sortDirection'] as DebugSortDirection,
  )
    ? (search['sortDirection'] as DebugSortDirection)
    : undefined;

  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
    ...(sortProperty ? { sortProperty } : {}),
    ...(search['sortProperty'] === null ? { sortProperty: null } : {}),
    ...(sortDirection ? { sortDirection } : {}),
  };
}

export function parseDebugRouteSearch(search: DebugRouteSearch): DebugListFilter {
  return {
    searchTerm: search.search ?? defaultDebugListFilter.searchTerm,
    page: search.page ? search.page - 1 : defaultDebugListFilter.page,
    size: search.size ?? defaultDebugListFilter.size,
    sortProperty:
      search.sortProperty === null
        ? null
        : (search.sortProperty ?? defaultDebugListFilter.sortProperty),
    sortDirection: search.sortDirection ?? defaultDebugListFilter.sortDirection,
  };
}

export function serializeDebugRouteSearch(filter: DebugListFilter): DebugRouteSearch {
  return {
    ...(filter.searchTerm.trim() ? { search: filter.searchTerm.trim() } : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultDebugListFilter.size ? { size: filter.size } : {}),
    ...(filter.sortProperty !== defaultDebugListFilter.sortProperty
      ? { sortProperty: filter.sortProperty }
      : {}),
    ...(filter.sortDirection !== defaultDebugListFilter.sortDirection
      ? { sortDirection: filter.sortDirection }
      : {}),
  };
}
